// frontend/src/hooks/useTeaching.js
//
// Data-driven "is this staff member teaching?" for the Staff Portal. A teacher is
// anyone with teaching DATA — subject allocations, a class-teacher assignment, or
// a stage-subject assignment — not just someone whose coarse role is `classTeacher`.
// This is what lets an "English teacher" (role `user`) see My Teaching, My
// Timetable and My Classes. The result is cached for the session so the layout and
// dashboard share one fetch.
import { useState, useEffect } from 'react';
import axios from 'axios';

const API  = process.env.REACT_APP_API_URL;
const hdrs = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

let cache = null; // in-flight or resolved promise, shared across mounts this session

const empty = { isTeaching: false, isAdmin: false, classTeacherOf: [], subjectClasses: [] };

function fetchScope() {
  if (cache) return cache;
  cache = axios
    .get(`${API}/api/academics/class-teacher/teaching-scope`, { headers: hdrs() })
    .then(({ data }) => {
      const classTeacherOf = data.classTeacherOf || [];
      const subjectClasses = data.subjectClasses || [];
      return {
        isAdmin: !!data.isAdmin,
        classTeacherOf,
        subjectClasses,
        isTeaching: !!(data.isAdmin || classTeacherOf.length || subjectClasses.length),
      };
    })
    .catch(() => ({ ...empty }));
  return cache;
}

// Clear the cache (e.g. on sign-out) so a different user doesn't inherit it.
export function resetTeachingCache() { cache = null; }

export function useTeaching() {
  const [state, setState] = useState({ ...empty, loading: true });

  useEffect(() => {
    let alive = true;
    fetchScope().then(res => { if (alive) setState({ ...res, loading: false }); });
    return () => { alive = false; };
  }, []);

  return state;
}
